<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-plus</v-icon>
      <h2 class="title ml-2">Agregar programa</h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="data">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              :items="dias"
              item-text="label"
              item-value="value"
              label="Día"
              v-model="programa.dia"
              :error-messages="errDia"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="programa.nombre"
              label="Nombre"
              :error-messages="errNombre"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="menuInicio"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="programa.inicio"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="programa.inicio"
                  label="Inicia"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menuInicio"
                v-model="programa.inicio"
                :max="programa.fin"
                full-width
                @click:minute="$refs.menu.save(programa.inicio)"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              ref="menu2"
              v-model="menuFin"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="programa.fin"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="programa.fin"
                  label="Finaliza"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menuFin"
                v-model="programa.fin"
                :min="programa.inicio"
                full-width
                @click:minute="$refs.menu2.save(programa.fin)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-textarea
          v-model="programa.descripcion"
          label="Descripción"
          :error-messages="errDescripcion"
        ></v-textarea>
        <!-- <v-file-input
          label="Imagen"
          v-model="programa.imagen"
          show-size
          accept="image/*"
        ></v-file-input> -->
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dias from '../helpers/dias'
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'save-programa',
  data () {
    return {
      dias,
      menuInicio: false,
      menuFin: false,
      programa: {
        dia: '',
        nombre: '',
        inicio: '',
        fin: '',
        descripcion: '',
        imagen: null
      }
    }
  },
  computed: {
    errDia () {
      const errs = []
      if (!this.$v.programa.dia.$dirty) return errs
      !this.$v.programa.dia.required && errs.push('El dia es requerido')
      return errs
    },
    errDescripcion () {
      const errs = []
      if (!this.$v.programa.descripcion.$dirty) return errs
      !this.$v.programa.descripcion.required && errs.push('La descrición es requerida')
      return errs
    },
    errNombre () {
      const errs = []
      if (!this.$v.programa.nombre.$dirty) return errs
      !this.$v.programa.nombre.required && errs.push('El nombre es requerido')
      return errs
    },
    errInicio () {
      const errs = []
      if (!this.$v.programa.inicio.$dirty) return errs
      !this.$v.programa.inicio.required && errs.push('La hora de inicio es requerida')
      return errs
    },
    errFin () {
      const errs = []
      if (!this.$v.programa.fin.$dirty) return errs
      !this.$v.programa.fin.required && errs.push('La hora de finalizacion es requerida')
      return errs
    }
  },
  methods: {
    save () {
      this.$v.programa.$touch()
      if (!this.$v.programa.$invalid) {
        this.$emit('save', this.programa)
      }
    },
    reset () {
      this.programa = {
        dia: '',
        nombre: '',
        inicio: '',
        fin: '',
        descripcion: '',
        imagen: null
      }
      this.$v.programa.$reset()
    }
  },
  mounted () {
    this.dias = [
      ...this.dias,
      {
        label: 'Lunes a viernes',
        value: 'semana'
      },
      {
        label: 'Todos los días',
        value: 'todos'
      }
    ]
  },
  validations: {
    programa: {
      descripcion: { required },
      dia: { required },
      nombre: { required },
      inicio: { required },
      fin: { required }
    }
  }
}
</script>
